import React from 'react';
import { useSelector } from 'react-redux';

import { Tooltip, Typography } from 'antd';
import { editorTypes } from '../../constants/tiptapEditorConstants';

import { selectCurrentEditorVersion } from '../../store/tiptapEditor.selectors';
import { selectDarkMode } from '../../../../../userBrowserSettings/store/browserSettings.selectors';

import { getTooltipOverlayClass } from '../../../../../utils/helpers/themeHelpers';

const classes = {
    headingCounter: 'heading-counter',
    active: 'active',
    tooltipOverlay: 'toolbar-tooltip-overlay',
};

// TODO: Return validation later, check https://dev.azure.com/websmithinc/Rankability/_git/Rankability/pullrequest/2494
const HeadingCounter = () => {
    const darkMode = useSelector(selectDarkMode);

    const activeOutlineVersion = useSelector(selectCurrentEditorVersion(editorTypes.OUTLINE));
    const totalHeaders = activeOutlineVersion?.heading_count?.total;

    if (!totalHeaders) return null;

    return (
        <Tooltip
            overlayClassName={`${classes.tooltipOverlay} ${getTooltipOverlayClass(darkMode)}`}
            placement='top'
            title='Number of headings in the outline.'
        >
            <Typography className={`${classes.headingCounter} ${classes.active}`}>
                {totalHeaders}
                <span>{totalHeaders > 1 ? ' headings' : ' heading'}</span>
            </Typography>
        </Tooltip>
    );
};

export default HeadingCounter;
